import { taskService } from '@/services'

export default {
  state: () => ({
    allTasks: [],
    tasks: [],
    tags: []
  }),

  mutations: {
    setAllTasks (state, value) {
      state.allTasks = value
    },

    setTasks (state, value) {
      state.tasks = value
    },

    updateTask (state, value) {
      const tasks = state.tasks.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            ...value
          }
        }
        return item
      })

      state.tasks = tasks
    },

    deleteTask (state, id) {
      const tasks = state.tasks.filter(item => item.id !== id)

      state.tasks = tasks
    },

    setTaskTags (state, value) {
      state.tags = value
    },

    toggleTaskTag (state, { tag, taskId, isSelected }) {
      const task = state.tasks.find(item => item.id === taskId)

      let tags = task.taskTags

      if (isSelected) {
        tags = tags.filter(t => t.id !== tag.id)
      } else {
        tags.push(tag)
      }

      const tasks = state.tasks.map(item => {
        if (item.id === taskId) {
          return {
            ...item,
            taskTags: tags
          }
        }
        return item
      })

      state.tasks = tasks
    }
  },

  actions: {
    getAllTasks ({ commit }, { tagIds, bookIds }) {
      return taskService.getAll({ tagIds, bookIds })
        .then(({ data }) => {
          commit('setAllTasks', data.tasks)
        })
    },

    getTasks ({ commit }, { tagIds, bookIds }) {
      return taskService.getAll({ tagIds, bookIds })
        .then(({ data }) => {
          commit('setTasks', data.tasks)
        })
    },

    createTask (_, data) {
      return taskService.create(data)
    },

    complete (_, { id, bookId }) {
      return taskService.complete({ id, bookId })
    },

    updateTask (_, data) {
      return taskService.update(data)
    },

    deleteTask ({ commit }, { id, bookId }) {
      commit('toggleBookLoading', true)

      return taskService.delete({ id, bookId })
        .then(_ => {
          commit('toggleBookLoading', false)
          commit('deleteTask', id)
        })
        .catch(() => commit('toggleBookLoading', false))
    },

    getTaskTags ({ commit }, bookIds) {
      taskService.getTaskTags(bookIds)
        .then(({ data }) => {
          commit('setTaskTags', data.tags)
        })
    },

    async toggleTaskTag ({ commit }, { tag, taskId, isSelected, bookId }) {
      commit('toggleTaskTag', { tag, taskId, isSelected })
      await taskService.toggleTaskTag({ tagId: tag.id, taskId, bookId })
    },

    updateTaskTag ({ commit, state }, { name, id, bookId }) {
      taskService.updateTaskTag({ name, id, bookId })
      const tags = state.tags.map(tag => {
        if (tag.id === id) {
          return {
            ...tag,
            name: name
          }
        }
        return tag
      })
      commit('setTaskTags', tags)
    }
  }
}
